import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import { GetReferralRequestSurveyDocument, GetReferralRequestSurveyQuery } from '../generated/survey';

type ReferralRequestSurvey = Omit<NonNullable<GetReferralRequestSurveyQuery['getReferralRequestSurvey']>, '__typename'>;

const useReferralRequestSurvey = (referralRequestId: string) => {
  const [{ data, fetching, errorMessage }] = useSecureGraphqlQuery<GetReferralRequestSurveyQuery>({
    query: GetReferralRequestSurveyDocument,
    variables: { referralRequestId },
    pause: !referralRequestId,
  });

  return { survey: data?.getReferralRequestSurvey ?? undefined, fetching, errorMessage };
};

export type { ReferralRequestSurvey };
export { useReferralRequestSurvey };
